import React, {
    useCallback,
} from 'react'
import {
    useNavigate,
} from 'react-router-dom'
import {
    openChatwoot,
} from '@src/services/chatwoot'
import AccessDenied from './components/AccessDenied'

function AccessDeniedPage(): JSX.Element {
    const navigate = useNavigate()
    const onBackClick = useCallback(() => {
        navigate('/', {
            replace: true,
        })
    }, [navigate])

    return (
        <AccessDenied
            onBackClick={onBackClick}
            handleOnSupportClick={openChatwoot}
        />
    )
}

export default AccessDeniedPage
